import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';

export const apiNetworkErrorInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            // 1) API server not reachable, network network-error
            if (error.status === 0) {
                // Launch a custom network-error to allow the fidelity page handler to show the appropriate network-error message/component
                const apiError = { error: { error: { title: 'FE-NETWORK-ERROR', messages: null } } };
                return throwError(() => apiError);
            }

            // 2) For every other network-error, ignore handling
            return throwError(() => error);
        })
    );
};
